import { render, staticRenderFns } from "./ModuleIcon.vue?vue&type=template&id=1a9ee0cd&"
import script from "./ModuleIcon.vue?vue&type=script&lang=js&"
export * from "./ModuleIcon.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports